<template>
    <v-container>
        <v-row>
            <v-col>
                <user-and-company-edit-card v-if="company_user && $route.name === 'user-and-company-edit'" />
                <user-and-company-card v-else />
                <ui-configuration-card class="mt-8" v-if="company_user"/>
            </v-col>
            <v-col>
                <integration-edit-card v-if="company_user && $route.name === 'integration-edit'" />
                <integration-card v-else />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import UserAndCompanyCard from "./cards/user-and-company-card";
import IntegrationCard from "./cards/integration-card";
import UserAndCompanyEditCard from "@/views/settings/cards/user-and-company-edit-card";
import IntegrationEditCard from "@/views/settings/cards/integration-edit-card";
import Store from "../../store";
import UiConfigurationCard from "@/views/settings/cards/ui-configuration-card.vue";

export default {
    name: "settings-view",
    data() {
        return {
            company_user: null
        };
    },
    components: {UiConfigurationCard, IntegrationEditCard, UserAndCompanyEditCard, IntegrationCard, UserAndCompanyCard },
    async mounted() {
        if (!this.user.id) await this.getLoggedUserData();
        if (!this.user.id) {
            return this.$router.push({ name: "Dashboard" });
        }
        await this.getUserData(this.user.id);
        if (this.activeUser.company_id) {
            this.company_user = this.activeUser.company_id;
            await this.getCompanyData(this.activeUser.company_id);
        }
    },
    destroyed() {
        Store.commit("setActiveUser", {});
        Store.commit("setActiveCompany", {});
    },
    methods: {
        ...mapActions(["getUserData", "getCompanyData", "getLoggedUserData"])
    },
    computed: {
        ...mapState(["user", "activeUser", "activeCompany", "activeCompanyBanks"])
    }
};
</script>

<style scoped></style>
